import Client from '../HttpClient';

const baseUrl = '/api/data';

const profile = (Token, MerchantId, BranchId) => {
	let headers = {};
	if (Token) headers = { ...headers, Token };
	if (MerchantId) headers = { ...headers, MerchantId };
	if (BranchId) headers = { ...headers, BranchId };
	return Client.get(
		`${baseUrl}/profile`,
		{},
		{
			headers,
		}
	);
};

export default {
	profile,
};
